__webpack_require__.p = "http://REPLACE_WITH_NEXT_PUBLIC_ASSET_PREFIX/_next/";